module.exports = __webpack_public_path__ + "static/media/lips.9de5c87a.svg";